import APIClient from '@/shared/http/clients/api'

const resourceName = 'automodel'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetAllByBrandID = (brandid, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/brand/${brandid}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIRegAuto}/${resourceName}/${id}`, config)

const AutoModelRepository = {
  GetAll,
  GetAllPaging,
  GetAllByBrandID,
  GetById,
  Create,
  Update,
  Delete
}

export default AutoModelRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/automodel.js